import {ChangeDetectorRef, Component, OnDestroy, OnInit} from "@angular/core";
import {SessionModel} from "../../orchestration/session.model";
import {Subscription} from "rxjs";
import {OrderingContextModel} from "../../ordering-context/ordering-context.model";
import {SessionEvents} from "../../orchestration/session-events";

/**
 * Standard page header image component
 */
@Component({
    selector: "woa-page-header-image",
    templateUrl: "./page-header-image.component.html"
})
export class PageHeaderImageComponent implements OnInit, OnDestroy {
    private subscriptions: Subscription = new Subscription();

    constructor(public sessionModel: SessionModel,
                public orderingContextModel: OrderingContextModel,
                private changeDetectorRef: ChangeDetectorRef) {
    }

    get showPageLogo(): boolean {
        return this.sessionModel.currentApp.showMobileHeaderVerticalLogo;
    }

    ngOnInit(): void {
        this.subscriptions.add(SessionEvents.currentApp$.subscribe(() => this.changeDetectorRef.detectChanges()));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/page-layout/page-header-image/page-header-image.component.ts